import { DialogRef } from '@angular/cdk/dialog';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { MODAL_DATA } from '@bcef/ia-components/upload';
import {
  ContextService,
  LabelsService,
  Language,
  provideAiguillage,
  provideLocaleId,
  provideOverlayContainer,
  provideTypology,
  withApimInterceptors,
} from '@bcef/ia-shared';
import { provideDataLayer } from '@difa/ia-data-layer';
import { provideTypologyFileUrl } from '@difa/ia-typology-files';
import { provideJsonConvert } from '@difa/ia-utils';
import { provideRouterStore, routerReducer } from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

import { environment } from '@environments/environment';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideStore(
      {
        router: routerReducer,
      },
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: false,
          strictActionSerializability: false,
        },
      },
    ),
    environment.providers,
    provideRouterStore({
      stateKey: 'router',
    }),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      // turn this to `true` if you want to enable 'fondu enchaîné' effect when navigating.
      // withViewTransitions({ skipInitialTransition: true }),
    ),
    provideAiguillage(),
    provideTranslateService({
      lang: Language.FR,
      fallbackLang: Language.FR,
      loader: provideTranslateLoader(LabelsService),
    }),
    provideLocaleId(),
    provideTypology(),
    provideTypologyFileUrl(() => {
      const context = inject(ContextService);
      return `/apps/ia-formulaire-gdpr/labels/ia-formulaire-gdpr-${context.language}-${context.typology}.json`;
    }),
    provideDataLayer({
      serviceName: 'starter-kit',
      prefix: 'dataLayer',
      // turn this property to `true` if you want to log warnings in the
      // console if some of your DataLayer objects
      // are formatted properly (only in development mode)
      // it needs the `prefix` property to be set in order to work
      checkDataLayerObjectsIntegrity: false,
    }),
    provideAppInitializer(() => inject(LabelsService).getTranslation()),
    provideHttpClient(withXhr(), withInterceptorsFromDi(), withApimInterceptors()),
    provideJsonConvert(),
    provideOverlayContainer(),
    {
      provide: DialogRef,
      useValue: {},
    },
    {
      provide: MODAL_DATA,
      useValue: new BehaviorSubject<unknown>(''),
    },
  ],
};
